<template lang="pug">
  .return-user-module.container(v-if="isMounted")
    .row.xs-f-small.md-f-medium.lg-f-small.max-at-tweak(v-if="showReturnUserModule")
      .modules-wrap.xs-12.text-center

        // declined payment method module
        .mini-module-box.text-center(v-if="showDeclinedPaymentMethodModule")
          .left-wrap.inline-block
            span.icon-card-break.color-slate.xs-f-xxlarge.sm-f-xlarge.md-f-xxxlarge.lg-f-xxlarge.max-at-tweak
              span.ada-tooltip card break icon
          .right-wrap.inline-block
            p.xs-f-xsmall.sm-f-xxsmall.md-f-small.lg-f-xsmall.max-at-tweak We can't process your next delivery
            a.semi-bold.xs-f-xsmall.sm-f-xxsmall.md-f-small.lg-f-xsmall.max-at-tweak(
              href="/account"
              @click="trackEvent('Return User Module Clicked', { module: 'Declined Payment', type: 'Braintree' });"
            ) Update payment info &rtrif;

        // declined amazon payment method module
        .mini-module-box.inline-block(
          v-if="showDeclinedAmazonPaymentMethodModule"
          v-for="(declined, index) in cdata.declinedPayment"
          :key="index"
        )
          .left-wrap.inline-block
            span.icon-card-break.color-slate.xs-f-xxlarge.sm-f-xlarge.md-f-xxxlarge.lg-f-xxlarge.max-at-tweak
              span.ada-tooltip card break icon
          .right-wrap.inline-block
            p.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak We can't process your next delivery
            a.semi-bold.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak(
              :href="`https://payments.amazon.com/mn/your-account/apa?action=renderChangePaymentBillingAgreement&contractId=${cdata.amazonPaymentIds[index]}`"
              @click="trackEvent('Return User Module Clicked', { module: 'Declined Payment', type: 'Amazon' });"
            ) Update payment info &rtrif;

        // upcoming colorbar appointment module
        .mini-module-box.inline-block(v-if="showUpcomingColorbarAppointmentModule")
          .left-wrap.inline-block
            span.icon-calendar.color-slate.xs-f-xxlarge.sm-f-xlarge.md-f-xxxlarge.lg-f-xxlarge.max-at-tweak
              span.ada-tooltip calendar icon
          .right-wrap.inline-block
            p.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak Next Hair Color Bar appt. {{ $formatDate(cdata.upcomingAppointment.date, 'M/D') }}
            a.semi-bold.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak(
              :href="`/colorbar/booking/${cdata.upcomingAppointment.location}`"
              @click="trackEvent('Return User Module Clicked', { module: 'Upcoming Appointment' });"
            ) Change or Cancel &rtrif;

        // restart subscription module
        .mini-module-box.inline-block(v-if="showRestartSubscriptionModule")
          .left-wrap.inline-block
            span.icon-subscription.color-slate.xs-f-xxlarge.sm-f-xlarge.md-f-xxxlarge.lg-f-xxlarge.max-at-tweak
              span.ada-tooltip subscription icon
          .right-wrap.inline-block
            p.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak Get product when you need it
            a.semi-bold.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak(
              href='/account/auto-delivery'
              @click="trackEvent('Return User Module Clicked', { module: 'Restart Subscription' })"
              data-mr-ass="restart-sub"
            ) Restart subscription &rtrif;

        // video-chat module
        .mini-module-box.inline-block(v-if="showVideoChatModule")
          .left-wrap.inline-block
            span.icon-question.color-slate.xs-f-xxlarge.sm-f-xlarge.md-f-xxxlarge.lg-f-xxlarge.max-at-tweak
              span.ada-tooltip question icon
          .right-wrap.inline-block
            p.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak We're here to help.
            a.semi-bold.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak(
              href="/schedule-video-chat"
              @click.prevent="onVideoConsultationClicked"
              data-mr-ass="book-video-chat"
            ) Book a free video color consult &rtrif;

        .mini-module-box.inline-block(v-else-if="showContactModule")
          .left-wrap.inline-block
            span.icon-question.color-slate.xs-f-xxlarge.sm-f-xlarge.md-f-xxxlarge.lg-f-xxlarge.max-at-tweak
              span.ada-tooltip question icon
          .right-wrap.inline-block
            p.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak We're here to help.
            a.semi-bold.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak(
              href="/support"
              @click="trackEvent('Return User Module Clicked',{ module: 'Talk to Expert' })"
              data-mr-ass="color-expert"
            ) Contact a professional colorist &rtrif;

        // membership module
        .mini-module-box.inline-block(v-if="showMembershipModule")
          .left-wrap.inline-block
            span.icon-process.color-slate.xs-f-xxlarge.sm-f-xlarge.md-f-xxxlarge.lg-f-xxlarge.max-at-tweak
              span.ada-tooltip process icon
          .right-wrap.inline-block
            p.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak Membership has great benefits
            a.semi-bold.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak(
              href="/membership"
              @click="trackEvent('Return User Module Clicked', { module: 'Membership' });"
              data-mr-ass="membership"
            ) Find out more &rtrif;

        // items in cart module
        .mini-module-box.inline-block(v-if="showItemsInCartModule")
          .left-wrap.inline-block
            span.icon-bag.color-slate.xs-f-xxlarge.sm-f-xlarge.md-f-xxxlarge.lg-f-xxlarge.max-at-tweak
              span.ada-tooltip bag icon
              span.cart-items-count.xs-f-small.sm-f-xsmall.md-f-medium.lg-f-xsmall {{cic}}
          .right-wrap.inline-block
            p.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak You have items in your cart
            a.semi-bold.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak(
              href="/cart"
              @click="trackEvent('Return User Module Clicked',{ module: 'Items in Cart' })"
              data-mr-ass="checkout-now"
            ) Checkout now &rtrif;

        // get recommendations module
        .mini-module-box.inline-block(v-if="showGetRecommendationsModule")
          .left-wrap.inline-block
            span.icon-tube.color-slate.xs-f-xxlarge.sm-f-xlarge.md-f-xxxlarge.lg-f-xxlarge.max-at-tweak
              span.ada-tooltip tube icon
          .right-wrap.inline-block
            p.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak Find your color
            a.semi-bold.xs-f-xsmall.sm-f-xxsmall.md-f-xsmall.max-at-tweak(
              href="/shop/hair-color"
              @click="trackEvent('Return User Module Clicked', { module: 'Get Recommendations' });"
              data-mr-ass="get-recommendations"
            ) Get recommendations &rtrif;
    .row.bottom-segment
</template>

<script>
  import { mapState } from 'vuex';

  export default {

    name: 'ReturnUserModule',

    inject: ['getObjProperty'],

    props: {
      hideMembershipModule: {
        type: Boolean,
        default: false,
      },
    },

    data:() => ({
      isMounted: false
    }),

    computed: {
      ...mapState('customer', [
        'cdata',
      ]),
      ...mapState('global', [
        'windowData',
      ]),
      ...mapState('colorAdvisor', [
        'advisorCompleted',
      ]),

      cic() {
        return this.$cookies.get('cic') || 0;
      },

      showReturnUserModule() {
        const { cid } = this.cdata || {};
        return !!cid;
      },

      showDeclinedPaymentMethodModule() {
        const { declinedPayment = [], hasDeclinedAmazonPayment } = this.cdata || {};
        return !!declinedPayment.length && !hasDeclinedAmazonPayment;
      },

      showDeclinedAmazonPaymentMethodModule() {
        const { declinedPayment = [], hasDeclinedAmazonPayment } = this.cdata || {};
        return !!declinedPayment.length && !!hasDeclinedAmazonPayment;
      },

      showUpcomingColorbarAppointmentModule() {
        const { upcomingAppointment: { date, location } = {} } = this.cdata || {};
        return !!date && !!location;
      },

      showRestartSubscriptionModule() {
        const { nextRefillDate, activeSubscriber, formerSubscriber } = this.cdata || {};
        return !nextRefillDate && !activeSubscriber && !!formerSubscriber;
      },

      showVideoChatModule() {
        return !this.advisorCompleted;
      },

      showContactModule() {
        const daysSinceFirstPurchase = this.getObjProperty(this.cdata, 'purchaseSummaryByType.color_kit.daysSinceFirstPurchase');
        return !(daysSinceFirstPurchase !== undefined && daysSinceFirstPurchase < 60 && this.windowData.breakpoint !== 'mobile');
      },

      showMembershipModule() {
        const { activeSubscriber } = this.cdata || {};
        return !this.hideMembershipModule && !activeSubscriber;
      },

      showItemsInCartModule() {
        return this.cic > 0;
      },

      showGetRecommendationsModule() {
        const { hasOrderedColorInLast3Months, currentColorSubscriber } = this.cdata || {};
        return !this.hideMembershipModule && !hasOrderedColorInLast3Months && !currentColorSubscriber;
      },
    },

    mounted () {
      this.isMounted = true;
    },

    methods: {
      onVideoConsultationClicked() {
        this.trackEvent('Return User Module Clicked',{
          module: 'Book a free video color consultation',
        });
        this.trackCTA('/schedule-video-chat', 'return_user_module');
      },
    }
  };
</script>

<style lang="stylus">
  .return-user-module
    .row
      padding 0.25em 0

    .mini-module-box
      display inline-block
      vertical-align top
      width 22em
      padding 0.5em 0

      &:nth-child(n + 4)
        display none !important

      .left-wrap
        width 3em

    .icon-bag
      position relative

    .cart-items-count
      color color-primary
      position absolute !important
      top 50%
      left 0
      right 0
      margin-top -0.6em

    .bottom-segment
      border-bottom 1px solid #E9E9E9

    @media mq-mobile
      .mini-module-box
        &:nth-child(n + 2)
          display none !important

    @media mq-tablet
      .mini-module-box
        width 20em

        &:nth-child(n + 3)
          display none !important

    @media mq-desktop-md
      .mini-module-box
        width 20em

        &:nth-child(n + 3)
          display none !important
</style>
